import { AttachmentWrapper as StyledAttachmentWrapper } from '../ChatSingle.styles';

const AttachmentWrapper = ({ children, $isMyMessage }) => {
  return (
    <StyledAttachmentWrapper $isMyMessage={$isMyMessage}>{children}</StyledAttachmentWrapper>
  );
};

export default AttachmentWrapper;
